// src/components/FakePaypalPayment.jsx
import axios from "axios";
import React from "react";
import { toast } from "react-toastify";

const FakePaypalPayment = ({ totalPrice, onSuccess, onError, details }) => {


  const generateCheckoutSession = async () => {
    const formData = new FormData();
    formData.append("product_name", details.name);
    formData.append("total", totalPrice);
    try {
      const res = await axios.post('https://motor-easy.clickbooster.io/api/paypal/create-payment', formData);
      const url = res.data.approval_url;
      window.location.href = url;
    } catch (err) {
      console.error('Failed to create checkout session: ', err);
      toast.error("Failed to process payment option");
    }
  }

  const handleSimulatePayment = () => {
    // Create dummy details to simulate a successful payment.
    const dummyDetails = {
      payer: {
        name: { given_name: "Test", surname: "User" },
        email_address: "test.user@example.com",
      },
      purchase_units: [
        { amount: { value: totalPrice.toString() } }
      ],
      status: "COMPLETED",
    };
    // Simulate a delay if needed, then call onSuccess.
    onSuccess(dummyDetails);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <button className="btn btn-success" onClick={generateCheckoutSession}>
        PayPal Payment (${totalPrice})
      </button>
    </div>
  );
};

export default FakePaypalPayment;
